
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiChevronDownGoogle as ObiChevronDownGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-chevron-down-google.js';
 
 
 

 
 export const ObiChevronDownGoogle = createComponent({
   react: React,
   tagName: 'obi-chevron-down-google',
   elementClass: ObiChevronDownGoogleElement,
   events: {
     
   }
  });
 
 